(() => {
  class RCProductGallery extends HTMLElement {
    connectedCallback() {
      this.controller?.abort();
      this.controller = new AbortController();
      this.zoom = this.closest('rc-product')?.querySelector('[data-rc-zoom]');
      const { signal } = this.controller;

      this.addEventListener('click', (event) => {
        const thumbnail = event.target.closest?.('[data-rc-thumbnail]');
        if (thumbnail && this.contains(thumbnail)) {
          this.selectMedia(thumbnail.dataset.rcThumbnail);
        }
        const preview = event.target.closest?.('[data-rc-open-zoom]');
        if (preview && this.contains(preview) && this.zoom) {
          const image = this.zoom.querySelector('[data-rc-zoom-image]');
          if (!image) return;
          image.src = preview.dataset.zoomSrc;
          image.alt = preview.dataset.zoomAlt || this.closest('rc-product')?.dataset.productTitle || '';
          if (!this.zoom.open) this.zoom.showModal();
        }
      }, { signal });

      this.zoom?.addEventListener('click', (event) => {
        if (event.target.closest?.('[data-rc-close-zoom]') || event.target === this.zoom) {
          this.zoom.close();
        }
      }, { signal });

      const initial = this.querySelector('[data-rc-media].is-active') || this.querySelector('[data-rc-media]');
      if (initial) {
        this.initialMediaId = initial.dataset.rcMedia;
        this.selectMedia(initial.dataset.rcMedia);
      }
    }

    disconnectedCallback() {
      this.controller?.abort();
      if (this.zoom?.open) this.zoom.close();
    }

    selectMedia(id) {
      const mediaItems = [...this.querySelectorAll('[data-rc-media]')];
      const selected = mediaItems.find((media) => media.dataset.rcMedia === String(id));
      if (!selected) return false;
      for (const media of mediaItems) {
        const active = media === selected;
        media.hidden = !active;
        media.classList.toggle('is-active', active);
        if (!active) media.querySelectorAll('video').forEach((video) => video.pause());
      }
      this.querySelectorAll('[data-rc-thumbnail]').forEach((thumbnail) => {
        const active = thumbnail.dataset.rcThumbnail === String(id);
        thumbnail.classList.toggle('is-active', active);
        thumbnail.setAttribute('aria-current', String(active));
      });
      if (this.zoom?.open) {
        const preview = selected.querySelector('[data-rc-open-zoom]');
        const image = this.zoom.querySelector('[data-rc-zoom-image]');
        if (preview && image) {
          image.src = preview.dataset.zoomSrc;
          image.alt = preview.dataset.zoomAlt || '';
        } else this.zoom.close();
      }
      return true;
    }

    restoreInitialMedia() {
      if (this.initialMediaId) this.selectMedia(this.initialMediaId);
    }

    selectImage(material) {
      if (!material?.image) return;
      if (material.mediaId && this.selectMedia(material.mediaId)) return;
      const stage = this.querySelector('.rc-product__stage');
      if (!stage) return;
      const previewId = 'rc-material-preview';
      let figure = this.querySelector('[data-rc-material-preview]');
      if (!figure) {
        figure = document.createElement('figure');
        figure.className = 'rc-product__media';
        figure.dataset.rcMedia = previewId;
        figure.dataset.rcMaterialPreview = '';
        const button = document.createElement('button');
        button.type = 'button';
        button.className = 'rc-product__preview';
        button.dataset.rcOpenZoom = '';
        button.setAttribute('aria-label', this.dataset.zoomLabel || material.name);
        const image = document.createElement('img');
        image.width = 540;
        image.height = 540;
        image.decoding = 'async';
        const label = document.createElement('span');
        label.className = 'rc-product__zoom-label';
        label.textContent = this.dataset.zoomLabel || material.name;
        button.append(image, label);
        figure.append(button);
        stage.append(figure);
      }
      const button = figure.querySelector('[data-rc-open-zoom]');
      const image = figure.querySelector('img');
      image.src = material.image;
      image.alt = material.name;
      button.dataset.zoomSrc = material.image;
      button.dataset.zoomAlt = material.name;
      const thumbnails = this.querySelector('.rc-product__thumbnails');
      if (thumbnails) {
        let thumbnail = thumbnails.querySelector('[data-rc-material-thumbnail]');
        if (!thumbnail) {
          thumbnail = document.createElement('button');
          thumbnail.type = 'button';
          thumbnail.className = 'rc-product__thumbnail';
          thumbnail.dataset.rcThumbnail = previewId;
          thumbnail.dataset.rcMaterialThumbnail = '';
          const sample = document.createElement('img');
          sample.width = 68;
          sample.height = 68;
          thumbnail.append(sample);
          thumbnails.prepend(thumbnail);
        }
        thumbnail.setAttribute('aria-label', material.name);
        const sample = thumbnail.querySelector('img');
        sample.src = material.thumbnail || material.image;
        sample.alt = material.name;
      }
      this.querySelector('.rc-product__placeholder')?.setAttribute('hidden', '');
      this.selectMedia(previewId);
    }
  }

  if (!customElements.get('rc-product-gallery')) {
    customElements.define('rc-product-gallery', RCProductGallery);
  }
})();
